import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiAlertTriangle } from 'react-icons/fi';
import Button from '../components/common/Button';

const NotFound = () => {
  const navigate = useNavigate();
  
  // 页面动画
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="min-h-screen flex items-center justify-center bg-[#f6f8fa] px-4 py-12 relative overflow-hidden"
    >
      {/* 品牌浅色光晕 */}
      <div className="absolute top-1/4 left-1/4 w-72 h-72 rounded-full opacity-30 blur-3xl bg-[#ddf4ff] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full opacity-30 blur-3xl bg-[#fbefff] pointer-events-none" />
      <div className="max-w-md w-full text-center relative z-10">
        <motion.div
          variants={itemVariants}
          className="text-6xl sm:text-8xl font-bold gradient-text mb-6"
        >
          404
        </motion.div>
        
        <motion.div
          variants={itemVariants}
          className="text-[#9a6700] flex justify-center mb-6"
        >
          <FiAlertTriangle size={50} />
        </motion.div>
        
        <motion.h1
          variants={itemVariants}
          className="text-2xl sm:text-3xl font-bold text-[#1f2328] mb-4"
        >
          页面未找到
        </motion.h1>
        
        <motion.p
          variants={itemVariants}
          className="text-[#656d76] mb-8"
        >
          抱歉，您访问的页面不存在或已被移除。
        </motion.p>
        
        <motion.div variants={itemVariants}>
          <Button
            onClick={() => navigate('/')}
            variant="primary"
            icon={<FiArrowLeft />}
          >
            返回首页
          </Button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default NotFound;